import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
const apiurl = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class ItemService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService,) { }

  createItem(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/item`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/item`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateItem(data: any): Observable<any> {
    return this.http.put<any>(`${apiurl}/item/${data.id}`, data).pipe(
      tap((response) => response)
    );
  }

  getChartData(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/item/chartdata/get`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getGroupItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/1`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getMainCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/2`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/3`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getSubCategoryItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/categoryhierarchy/level/4`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  deleteItem(data: any): Observable<any> {
      return this.http.post<any>(`${apiurl}/item/delete`, data).pipe(
        tap((response) => response),
        catchError((error) => this.errorHandler.handleError(error))
      );
    }
}
